export const Transitions = {
  custom: "all 0.18s cubic-bezier(0.42, 0, 0.58, 0.97)",
};
